import { render, staticRenderFns } from "./PushData.vue?vue&type=template&id=2a053107&scoped=true&"
import script from "./PushData.vue?vue&type=script&lang=js&"
export * from "./PushData.vue?vue&type=script&lang=js&"
import style0 from "./PushData.vue?vue&type=style&index=0&id=2a053107&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a053107",
  null
  
)

export default component.exports